import jquery from "jquery";
window.$ = window.jQuery = jquery;
import Flickity from 'flickity';

const selectors = {
    slider: '[data-section-type="testimonials"] .testimonial-list',
    sliderItem: '.testimonial-item__wrapper'
}

jQuery(function() {
    if($(window).outerWidth() < 641 ) {
        if($(selectors.sliderItem).length > 2){
            const $carousel = $(selectors.slider);
            var flkty = new Flickity( selectors.slider, {
                pageDots: false,
                prevNextButtons: true,
                wrapAround: true,
                autoPlay: 5000,
                resize: false,
                watchCSS: false,
                draggable: true,
                fade: 'fade',
                cellAlign: 'left',
                adaptiveHeight: true,
                autoPlay: 4000,
                selectedAttraction: 0.2,
                friction: 0.8
            });
        }
    }
})